import axiosInstance from './axios';

interface SystemConfig<T> {
  key: string;
  value: T;
}

const base = 'system-config';
export const getBillingIntervalTimeConfig = async (): Promise<SystemConfig<number>> => {
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url: `${base}/billing-interval-time`,
    });
    return parseNumberConfig(data);
  } catch (error) {
    console.log('Error on getBillingIntervalTimeConfig', error);
    throw error;
  }
};

export const getHideCloverMonitoringConfig = async (): Promise<SystemConfig<boolean>> => {
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url: `${base}/hide-clover-monitoring`,
    });
    return parseBooleanConfig(data);
  } catch (error) {
    console.error('Error on getHideCloverMonitoringConfig', error);
    throw error;
  }
};

const parseBooleanConfig = (config: SystemConfig<any>): SystemConfig<boolean> => {
  return {
    key: config.key,
    value: config.value === '1',
  };
};

const parseNumberConfig = (config: SystemConfig<any>): SystemConfig<number> => {
  return {
    key: config.key,
    value: Number(config.value),
  };
};
